<script>
	// ABET chip loader — the real one. Center glyph = α (U+03B1, the ABET mark),
	// ported from abet-dashboard's yc() component and upgraded: metal-look face,
	// beveled gold edge teeth, double rim, hot-core glow. Flip keyframes exact.
	export let size = 76;
	export let message = 'Loading.';
	export let showLabel = true;

	const gold = '#FDB515';

	const faceStyle = {
		position: 'absolute',
		inset: 0,
		borderRadius: '50%',
		display: 'grid',
		placeItems: 'center',
		backfaceVisibility: 'hidden',
		border: `3px solid ${gold}`,
		outline: '1px solid rgba(253,181,21,0.45)',
		outlineOffset: '-5px',
		background: `
			radial-gradient(circle at 30% 24%, rgba(255,255,255,0.16), transparent 34%),
			radial-gradient(circle at 68% 78%, rgba(253,181,21,0.10), transparent 40%),
			radial-gradient(circle at 34% 30%, #29405a 0%, #16222f 45%, #0d131c 68%, #070B0F 100%)`,
		boxShadow: `
			0 0 28px rgba(253,181,21,0.34),
			0 0 64px rgba(253,181,21,0.12),
			inset 0 0 18px rgba(253,181,21,0.14),
			inset 0 2px 6px rgba(0,0,0,0.65)`
	};

	const glyphStyle = {
		fontFamily: "'Times New Roman', serif",
		fontSize: Math.round(size * 0.56),
		fontWeight: 700,
		color: gold,
		textShadow: `
			0 0 6px rgba(253,181,21,0.95),
			0 0 22px rgba(253,181,21,0.55),
			0 0 42px rgba(253,181,21,0.28)`,
		lineHeight: 0.88,
		transform: 'translateY(-1px)'
	};

	const segStyle = (o) => ({
		position: 'absolute',
		left: '50%',
		top: 2,
		width: Math.max(6, Math.round(size * 0.10)),
		height: Math.max(9, Math.round(size * 0.135)),
		marginLeft: -Math.max(3, Math.round(size * 0.05)),
		borderRadius: 3,
		background:
			'linear-gradient(180deg, rgba(255,214,102,1) 0%, rgba(253,181,21,0.92) 45%, rgba(180,120,8,0.9) 100%)',
		boxShadow: 'inset 0 1px 1px rgba(255,255,255,0.45), inset 0 -1px 2px rgba(80,50,0,0.6)',
		transformOrigin: `50% ${size / 2 - 2}px`,
		transform: `rotate(${o * 45}deg)`
	});

	const styleStr = (o) =>
		Object.entries(o)
			.filter(([, v]) => v !== undefined && v !== null)
			.map(([k, v]) =>
				`${k.replace(/[A-Z]/g, (c) => '-' + c.toLowerCase())}:${typeof v === 'number' && !['flexGrow','zIndex','opacity','lineHeight','fontWeight'].includes(k) ? v + 'px' : v}`)
			.join(';');

	const segs = Array.from({ length: 8 }, (_, o) => o);
	const backFace = { ...faceStyle, transform: 'rotateY(180deg)' };

	const keyframes = `
    @keyframes abet-chip-flip {
      0%   { transform: rotateY(0deg)   translateY(0) }
      45%  { transform: rotateY(540deg) translateY(-10px) }
      70%  { transform: rotateY(720deg) translateY(0) }
      78%  { transform: rotateY(720deg) translateY(-3px) }
      86%  { transform: rotateY(720deg) translateY(0) }
      100% { transform: rotateY(720deg) translateY(0) }
    }
    @media (prefers-reduced-motion: reduce) {
      .abet-chip-spinner { animation: none !important }
    }
  `;
</script>

{@html `<style>${keyframes}</style>`}

<div style="display:flex;flex-direction:column;align-items:center;gap:16px;padding:38px 0;" role="status" aria-live="polite">
	<div style="perspective:620px;width:{size}px;height:{size}px;">
		<div class="abet-chip-spinner" style="position:relative;width:100%;height:100%;transform-style:preserve-3d;animation:abet-chip-flip 2.4s cubic-bezier(.45,.05,.35,1) infinite;">
			<div style={styleStr(faceStyle)}>
				{#each segs as o}
					<span style={styleStr(segStyle(o))}></span>
				{/each}
				<span style={styleStr(glyphStyle)}>α</span>
			</div>
			<div style={styleStr(backFace)}>
				{#each segs as o}
					<span style={styleStr(segStyle(o))}></span>
				{/each}
				<span style={styleStr(glyphStyle)}>α</span>
			</div>
		</div>
	</div>
	{#if showLabel && message}
		<span style="font-size:13px;letter-spacing:0.04em;opacity:0.75;">{message}</span>
	{/if}
</div>

<style>
	.abet-chip-loader {
		display: contents;
	}
</style>